var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5891 0.410582C11.9145 0.736018 11.9145 1.26366 11.5891 1.58909L1.58909 11.5891C1.26366 11.9145 0.736018 11.9145 0.410582 11.5891C0.0851447 11.2637 0.0851447 10.736 0.410582 10.4106L10.4106 0.410582C10.736 0.0851447 11.2637 0.0851447 11.5891 0.410582Z",
    fill: "#727E8D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.410582 0.410582C0.736018 0.0851447 1.26366 0.0851447 1.58909 0.410582L11.5891 10.4106C11.9145 10.736 11.9145 11.2637 11.5891 11.5891C11.2637 11.9145 10.736 11.9145 10.4106 11.5891L0.410582 1.58909C0.0851447 1.26366 0.0851447 0.736018 0.410582 0.410582Z",
    fill: "#727E8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.2b83213aa4d700e99b19558ae6a9703b.svg";
export { ForwardRef as ReactComponent };